// extracted by mini-css-extract-plugin
module.exports = {"bgColorPrimary":"var(--mainColor6)","bgColorButtonSecondary":"bg-color-button-secondary","green":"var(--mainColor13)","red":"var(--mainColor5)"};